export default __webpack_public_path__ + "static/media/img7.1a0b3702.png";